import React, { useEffect, useRef } from 'react';
import {
  Box,
  BoxProps,
  Button,
  MobileStepper,
  Typography,
  useTheme,
} from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { StatefulButton } from './StatefulButton';
import { steps } from '../constants/steps';
import { useBaseStepperContext } from '../../shared/contexts/BaseStepperContext';
import WarningMessage from '../../shared/components/WarningMessage/WarningMessage';
import ScrollToTopBox from '../../shared/components/ScrollToTopBox/ScrollToTopBox';

export const MyMobileStepper: React.FC = () => {
  const {
    activeStep,
    handleNext,
    handleBack,
    warningMessage,
    showWarning,
    isLastStep,
  } = useBaseStepperContext();

  const maxSteps = steps.length;
  const theme = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left of the window
  }, [activeStep]);

  return (
    <Box
      sx={{
        height: 'calc(100vh - 65px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <Typography variant="h6" sx={{ p: 2 }}>
          {steps[activeStep].label}
        </Typography>
        <ScrollToTopBox sx={{ p: 2 }}>
          {steps[activeStep].component &&
            React.createElement(steps[activeStep].component, {
              label: steps[activeStep].label,
              description: steps[activeStep].description,
              stepIndex: activeStep,
            })}
        </ScrollToTopBox>
      </Box>

      <Box sx={{ flexShrink: 0 }}>
        {/* Warning message display above mobile stepper */}
        <Box sx={{ mr: 2, ml: 2 }}>
          <WarningMessage message={warningMessage} show={showWarning} />
        </Box>

        <MobileStepper
          sx={{
            borderColor: theme.palette.divider,
            borderTop: '1px solid',
            m: 1,
          }}
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          nextButton={
            <StatefulButton
              size="small"
              onClick={handleNext}
              allowNavigation={true}
              disabled={isLastStep() || showWarning}
            >
              Next
              {theme.direction === 'rtl' ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </StatefulButton>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              {theme.direction === 'rtl' ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
              Back
            </Button>
          }
        />
      </Box>
    </Box>
  );
};
